/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IssueFixesRouteImport } from './routes/issue-fixes'
import { Route as AccessibilityToolbarRouteImport } from './routes/accessibility-toolbar'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StatementIndexRouteImport } from './routes/statement/index'

const IssueFixesRoute = IssueFixesRouteImport.update({
  id: '/issue-fixes',
  path: '/issue-fixes',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityToolbarRoute = AccessibilityToolbarRouteImport.update({
  id: '/accessibility-toolbar',
  path: '/accessibility-toolbar',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatementIndexRoute = StatementIndexRouteImport.update({
  id: '/statement/',
  path: '/statement/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/issue-fixes': typeof IssueFixesRoute
  '/accessibility-toolbar': typeof AccessibilityToolbarRoute
  '/statement': typeof StatementIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/issue-fixes': typeof IssueFixesRoute
  '/accessibility-toolbar': typeof AccessibilityToolbarRoute
  '/statement': typeof StatementIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/issue-fixes': typeof IssueFixesRoute
  '/accessibility-toolbar': typeof AccessibilityToolbarRoute
  '/statement/': typeof StatementIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/issue-fixes' | '/accessibility-toolbar' | '/statement'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/issue-fixes' | '/accessibility-toolbar' | '/statement'
  id: '__root__' | '/' | '/issue-fixes' | '/accessibility-toolbar' | '/statement/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  IssueFixesRoute: typeof IssueFixesRoute
  AccessibilityToolbarRoute: typeof AccessibilityToolbarRoute
  StatementIndexRoute: typeof StatementIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/issue-fixes': {
      id: '/issue-fixes'
      path: '/issue-fixes'
      fullPath: '/issue-fixes'
      preLoaderRoute: typeof IssueFixesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility-toolbar': {
      id: '/accessibility-toolbar'
      path: '/accessibility-toolbar'
      fullPath: '/accessibility-toolbar'
      preLoaderRoute: typeof AccessibilityToolbarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/statement/': {
      id: '/statement/'
      path: '/statement'
      fullPath: '/statement'
      preLoaderRoute: typeof StatementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  IssueFixesRoute: IssueFixesRoute,
  AccessibilityToolbarRoute: AccessibilityToolbarRoute,
  StatementIndexRoute: StatementIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
